/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCsrf200Response
 */
export interface GetCsrf200Response {
    /**
     * CSRFトークン送信用パラメータ名
     * @type {string}
     * @memberof GetCsrf200Response
     */
    parameterName: string;
    /**
     * CSRFトークン送信用ヘッダー名
     * @type {string}
     * @memberof GetCsrf200Response
     */
    headerName: string;
    /**
     * CSRFトークン値
     * @type {string}
     * @memberof GetCsrf200Response
     */
    token: string;
}

/**
 * Check if a given object implements the GetCsrf200Response interface.
 */
export function instanceOfGetCsrf200Response(value: object): boolean {
    if (!('parameterName' in value)) return false;
    if (!('headerName' in value)) return false;
    if (!('token' in value)) return false;
    return true;
}

export function GetCsrf200ResponseFromJSON(json: any): GetCsrf200Response {
    return GetCsrf200ResponseFromJSONTyped(json, false);
}

export function GetCsrf200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCsrf200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'parameterName': json['parameterName'],
        'headerName': json['headerName'],
        'token': json['token'],
    };
}

export function GetCsrf200ResponseToJSON(value?: GetCsrf200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'parameterName': value['parameterName'],
        'headerName': value['headerName'],
        'token': value['token'],
    };
}

